
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ChangeProjectsBlock/ChangeProjectsBlock.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ChangeProjectsBlock.html');
        
        var script = require('./ChangeProjectsBlock.ts').default;
        module.exports = require('./ChangeProjectsBlock.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    